import React, {useState, useEffect} from 'react';
import { DataGrid } from '@mui/x-data-grid';
import logo from '../../assets/images/logo-win.svg'; 
import "../../assets/css/home.css";
import { savePrescription, unlockRXDetails, fetchAvailityMemberCoverage, availityOonUmrValidation,
  saveCostShareRebateData, getPremierAccumulatorModels, saveRXCostshareDetails, saveUpdateClaimData
  , loadRxDetails, loadRebateValidationFlag, loadMemberConcern } from '../../Services/loadOrder';
import { FcPrint } from "react-icons/fc";
import toast, {Toaster} from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import ThankYouModal from './ThankYouModal';

  


const OrderSummary = ({
  flag,
  rxData,
    gridRows,
    menopurGridRows,
    maingridRows,
   // columns,
    totalAmount,
    userId,
   shippingCarrier,
    trackingNumber,
    taskId,
    pharmacyId,
    notes,
    TotalWinPays,
    TotalMemberPays,
    TotalCopay,
    TotalMenopurCostShare, 
    totalWinCardAmount,
    //RebateValidationFlag,
    PharmReimbWithoutRebate,
    PharmReimbWithRebate,
    Contract,
    onCancel }) => {

        const [isSubmitting, setIsSubmitting] = useState(false);
        const navigate = useNavigate();
        const [showThankYou, setShowThankYou] = useState(false);
         const [rebateValidationFlag, setRebateValidationFlag] = useState('');
        const [billedAmount, setBilledAmount] = useState(0);
        const [memberConcernFlag, setMemberConcernFlag] = useState(false);
        const HealthPlanId = rxData[0]?.HealthPlanId;
        console.log("This is HealthPlanId in OrderSummary", HealthPlanId);


        console.log("This is rxData in OrderSummary", rxData);
        console.log("This is gridRows in OrderSummary", gridRows);
        console.log("This is data For sipping", shippingCarrier, trackingNumber);
        console.log("This is totalCopay in OrderSummary", TotalCopay);
        console.log("This is totalMemberPays in OrderSummary", TotalMemberPays);        

        useEffect(() => {
    const fetchRebateFlag = async () => {
      const contract =
        rxData?.Contract ||
        rxData[0]?.Contract ||
        rxData?.TaskDetail?.Contract ||
        rxData?.TaskDetail?.[0]?.Contract ||
        '';
      const memberId =
        rxData?.MemberID ||
        rxData[0]?.MemberID ||
        rxData?.TaskDetail?.MemberID ||
        rxData?.TaskDetail?.[0]?.MemberID ||
        '';

        console.log("loadRebateValidationFlag payload", {contract, memberId, pharmacyId, userId});
      
        if (rxData[0]?.ContractType === 'Premier' || rxData?.ContractType === 'Premier' 
        || contract === "Moelis-Cigna-Premier Rx"
        ) {
          const memberConcern = await loadMemberConcern(taskId, contract);
          if (memberConcern.data?.Flag === 'Y') {
            setMemberConcernFlag(true);
          }
        }
        if (contract && memberId && pharmacyId && userId) {
        const rebateFlag = await loadRebateValidationFlag(
          contract,
          memberId,
          pharmacyId,
          userId
        );
        if (rebateFlag?.Validation === 'Y') {
          setRebateValidationFlag('Y');
           setBilledAmount(PharmReimbWithRebate);
        } else if (rebateFlag?.Validation === 'N') {
          setRebateValidationFlag('N');
          setBilledAmount(PharmReimbWithoutRebate);
        }
      }
    };
    fetchRebateFlag();
  }, [rxData, pharmacyId, userId]);

 
        

  const filledDate = new Date();
  const formattedDate = filledDate.toLocaleDateString();
  const formattedTime = filledDate.toLocaleTimeString();

   console.log("This is rebateFlag ", rebateValidationFlag);

  const handleProceed = async () => {
  //   if (Contract === 'CIGNA') {
  //   setShowThankYou(true);
  //   return;
  // }
    console.log("This is rx Data",rxData);
    console.log("This is Rebate Validation Flag", rebateValidationFlag);

    if (isSubmitting) {
        console.log("[BLOCKED] Duplicate submit attempt prevented.");
        return;
      }
    
      console.log("[RUN] handleProceed() fired");
      setIsSubmitting(true);

    // Safely get the first task detail object
const firstTaskDetail = rxData?.[0] || rxData?.TaskDetail?.[0] || {};

// Contract
const contract =
  rxData?.Contract ||
  firstTaskDetail?.Contract || Contract ||
  undefined ;
  console.log("Contract:", contract);

// MemberID
const memberID =
  rxData?.MemberID ||
  firstTaskDetail?.MemberID ||
  undefined;
console.log("MemberID:", memberID);
// GroupID
const groupId =
  rxData?.GroupID ||
  firstTaskDetail?.GroupID || "";
console.log("GroupID:", groupId);
// AuthNo
const authNo =
  rxData?.AuthNo ||
  firstTaskDetail?.AuthNo ||
  undefined;
  console.log("AuthNo:", authNo);
  const PriorityID =
  rxData?.PriorityID ||
  firstTaskDetail?.PriorityID ||
  undefined;
  console.log("PriorityID:", PriorityID);
    const costShareValue = TotalMemberPays|| rxData?.CostShare || rxData?.Prescriptions?.CostShare || rxData?.Prescriptions[0]?.CostShare || 0;
    console.log("CostShare:", costShareValue);

    const contractType = rxData?.ContractType || firstTaskDetail?.ContractType || "";

  
    if (!contract || !taskId || !memberID) {
      toast.error("Missing required prescription data. Cannot proceed.");
      navigate('/error-page');
      setIsSubmitting(false);
      return;
    }

  
    setIsSubmitting(true);
    try {
      // Submit all drug-level prescriptions (Loop = 1)
      if (flag !== 'Needs') { 
      for (const row of gridRows) {
        const drugPayload = {
          Loop: 1,
          Flag: "Submit",
          Contract: contract,
          PharmacyID: pharmacyId,
          TaskID: taskId,
          LineID: row?.PresID?.toString() || "", 
          NDC: row?.NDC,
          DispQty: row?.DispQty || row?.['Disp Qty'],
         // Copay: 0, //member pay for premier
         // Amount: parseFloat(row?.ReimbursementAmount || 0), // reimbursement amount
          Copay: parseFloat(row?.['Member Pays'] || 0),
          Amount: parseFloat(row?.['Reimbursment Amount'] || parseFloat(row.Amount) || 0),
          TaskType: "",
          UserID: userId,
          ScheduleStartDate: rxData?.SchStartDate || rxData?.TaskDetail?.SchStartDate || rxData[0]?.SchStartDate || rxData[0]?.TaskDetail?.SchStartDate,
          ScheduleEndDate: rxData?.SchEndDate || rxData?.TaskDetail?.SchEndDate || rxData[0]?.SchEndDate || rxData[0]?.TaskDetail?.SchEndDate,
          Message: notes ||  "",
          MemberID: memberID,
          AuthNo: authNo,
          TotCoPay: TotalCopay,
          TotAmount: parseFloat(TotalWinPays),
          PriorityID: PriorityID,
          ShippingCarrier: shippingCarrier || "",
          TrackingNo: trackingNumber || "",
          Notes: "",
          Reason: row?.Reason || "",
        //   RebateAmount: 0,
          WithWinMarginWithoutRebate:  parseFloat(row?.ReimbursementAmountValue || 0),
          WintoPharmAmt: parseFloat(row?.ReimbursementAmountDisplay || 0) - 0
        };
        await savePrescription(drugPayload);
      }};
  
      // Submit task-level summary (Loop = 0)
      const taskPayload = {
        Loop: 0,
        Flag: "Submit",
        Contract: contract,
        PharmacyID: pharmacyId,
        TaskID: taskId,
        LineID: "",
        NDC: "",
        DispQty: 0,
        Copay: 0,
        Amount: parseFloat(totalAmount) || 0, // Ensure totalAmount is a number
        TaskType: "",
        UserID: userId,
        ScheduleStartDate: rxData?.SchStartDate || rxData?.TaskDetail?.SchStartDate || rxData[0]?.SchStartDate || rxData[0]?.TaskDetail?.SchStartDate,
        ScheduleEndDate: rxData?.SchEndDate || rxData?.TaskDetail?.SchEndDate || rxData[0]?.SchEndDate || rxData[0]?.TaskDetail?.SchEndDate,
        Message: notes || "",
        MemberID: memberID,
        AuthNo: authNo,
        TotCoPay: parseFloat(TotalCopay) || 0, // Ensure TotalMemberPays is a number
        TotAmount: parseFloat(TotalWinPays),
        PriorityID: PriorityID,
        ShippingCarrier: shippingCarrier || "",
        TrackingNo: trackingNumber || "",
        Notes: "",
        Reason: "", // No reason for task-level
        // RebateAmount: 0,
        WithWinMarginWithoutRebate: PharmReimbWithoutRebate, 
        WintoPharmAmt: parseFloat(TotalWinPays) - 0,
      };
      
        // Log the task-level payload for debugging
        

      console.log("Saving task-level payload:", taskPayload);
      await savePrescription(taskPayload);
      
      toast.success("Prescription submitted successfully!");

      if ((contractType === "Premier" || contract === 'Moelis-Cigna-Premier Rx') && contract !== "Chewy-Aetna-Premier") {

        const result = await getPremierAccumulatorModels(contract);
        
                if (result?.AccumAccess === 'Y') {
                  if (flag !== 'Needs') {
                   await saveCostShareRebateData(PharmReimbWithRebate,
                     PharmReimbWithoutRebate,
                      rebateValidationFlag, costShareValue, authNo,  taskId, contract,userId, memberID, TotalMenopurCostShare );
                    await saveRXCostshareDetails(taskId,
                      contract,
                       memberID,
                        userId,
                         authNo,
                            PharmReimbWithRebate,
                             rebateValidationFlag, 
                             PharmReimbWithoutRebate, 
                             0);
                }
              }
      
      
    // --- Availity Member Coverage Payload Construction ---
    let taskPayload1 = rxData?.TaskDetail?.[0] || rxData?.[0] || {};
    let taskPayload2 = rxData?.TaskDetail?.[1] || rxData?.[1] || {};
    let memberId ;
    if (contractType === "Premier") { 
      memberId = HealthPlanId
    }else {
      memberId = memberID;
    }
    let memberName = taskPayload1?.MemberName;
    let patientFirstName =  memberName.split(',')[1] || '';
    let patientLastName = memberName.split(',')[0] || '';
    let patientBirthDate =taskPayload1?.DOB;
    let contractName = contract;
    let sourceSystem = "PBMS";
    let user = userId;

    // Handle test data as in C#
    if (
      memberId?.toLowerCase().includes("test") &&
      patientFirstName?.toLowerCase().includes("test") &&
      patientLastName?.toLowerCase().includes("test")

    ) {
      if (contractType === "Premier") {
      memberId = "090781558_00";
      }
      patientFirstName = "Yolanda";
      patientLastName = "Bryce";
      patientBirthDate = "03/26/1983";
      contractName = "Memorial Sloan Kettering (MSK)-Aetna-Premier";
      sourceSystem = "PBMS Test";
      user = "CHDV";
    }

    // Call Availity Member Coverage
    const availityData = await fetchAvailityMemberCoverage(
      memberId,
      patientFirstName,
      patientLastName,
      patientBirthDate,
      contractName,
      sourceSystem,
      user
    );

    // OON/UMR Validation
    const oonValidation = await availityOonUmrValidation(
      contract,
      memberId,
      user
    );

    try {
    // ---- Availity Data Extraction (C# logic adapted) ----
    let aVL_GROUP_ID = "";
    let aVL_PATIENT_SUB_FLAG = "";
    let aVL_SUBSCRIBER_FIRST_NAME = "";
    let aVL_SUBSCRIBER_ID = "";
    let aVL_SUBSCRIBER_LAST_NAME = "";
    let aVL_SUBSCRIBER_REL_FLAG = "";
    let aVL_MEMB_GENDER = "";
    let aVL_SUB_GENDER = "";
    let eRROR = "";
    let aVL_DEDUCTIBLE_Total = "0.00";
    let aVL_DEDUCTIBLE = "0.00";
    let aVL_CO_INS = "0.00";
    let aVL_COPAY = "0.00";
    let aVL_OOP_Total = "0.00";
    let aVL_OOP_REM = "0.00";

    if (availityData) {
      if (availityData.apiStatus === "Complete") {
        try {
          const plans = availityData?.plans || [];
          const patient = availityData?.patient || {};
          const subscriber = availityData?.subscriber || {};

          aVL_GROUP_ID = plans[0]?.groupNumber || "";
          aVL_PATIENT_SUB_FLAG = patient.subscriberRelationship === "Self" ? "N" : "Y";
          aVL_SUBSCRIBER_FIRST_NAME = subscriber.firstName || "";
          aVL_SUBSCRIBER_ID = subscriber.memberId || "";
          aVL_SUBSCRIBER_LAST_NAME = subscriber.lastName || "";
          aVL_SUBSCRIBER_REL_FLAG = patient.subscriberRelationship || "";
          aVL_SUB_GENDER = subscriber.gender || "";
          aVL_MEMB_GENDER = patient.gender || "";
       
          // Use oonValidation or similar logic to get ValidateFlg
          let ValidateFlg = "";
          if (oonValidation && oonValidation.HealthPlan) {
            ValidateFlg = oonValidation.HealthPlan;
          }

          // Helper to format values
          const formatValue = (value) => {
            if (typeof value === "string" && value.length > 0) {
              return value.replace("$", "").replace("%", "").trim();
            }
            return "0";
          };

          if (ValidateFlg === "Y") {
            aVL_DEDUCTIBLE_Total = formatValue(plans[0]?.benefits?.[1]?.amounts?.deductibles?.inNetwork?.[0]?.total) || "0";
            aVL_DEDUCTIBLE = formatValue(plans[0]?.benefits?.[1]?.amounts?.deductibles?.inNetwork?.[0]?.remaining) || "0";
            aVL_CO_INS = formatValue(plans[0]?.benefits?.[1]?.amounts?.coInsurance?.inNetwork?.[0]?.amount) || "0";
            aVL_COPAY = formatValue(plans[0]?.benefits?.[1]?.amounts?.coPayment?.inNetwork?.[0]?.amount) || "0";
            aVL_OOP_Total = formatValue(plans[0]?.benefits?.[1]?.amounts?.outOfPocket?.inNetwork?.[0]?.total) || "0";
            aVL_OOP_REM = formatValue(plans[0]?.benefits?.[1]?.amounts?.outOfPocket?.inNetwork?.[0]?.remaining) || "0";
          } else if (ValidateFlg === "Cigna") {
            aVL_DEDUCTIBLE_Total = formatValue(plans[0]?.benefits?.[0]?.amounts?.deductibles?.inNetwork?.[0]?.total) || "0";
            aVL_DEDUCTIBLE = formatValue(plans[0]?.benefits?.[0]?.amounts?.deductibles?.inNetwork?.[0]?.remaining) || "0";
            aVL_CO_INS = formatValue(plans[0]?.benefits?.[0]?.amounts?.coInsurance?.inNetwork?.[0]?.amount) || "0";
            aVL_COPAY = formatValue(plans[0]?.benefits?.[1]?.amounts?.coPayment?.inNetwork?.[0]?.amount) || "0";
            aVL_OOP_Total = formatValue(plans[0]?.benefits?.[0]?.amounts?.outOfPocket?.inNetwork?.[0]?.total) || "0";
            aVL_OOP_REM = formatValue(plans[0]?.benefits?.[0]?.amounts?.outOfPocket?.inNetwork?.[0]?.remaining) || "0";
          } else {
            aVL_DEDUCTIBLE_Total = formatValue(plans[0]?.benefits?.[0]?.amounts?.deductibles?.inNetwork?.[0]?.total) || "0";
            aVL_DEDUCTIBLE = formatValue(plans[0]?.benefits?.[0]?.amounts?.deductibles?.inNetwork?.[0]?.remaining) || "0";
            aVL_CO_INS = formatValue(plans[0]?.benefits?.[1]?.amounts?.coInsurance?.inNetwork?.[0]?.amount) || "0";
            aVL_COPAY = formatValue(plans[0]?.benefits?.[1]?.amounts?.coPayment?.inNetwork?.[0]?.amount) || "0";
            aVL_OOP_Total = formatValue(plans[0]?.benefits?.[0]?.amounts?.outOfPocket?.inNetwork?.[0]?.total) || "0";
            aVL_OOP_REM = formatValue(plans[0]?.benefits?.[0]?.amounts?.outOfPocket?.inNetwork?.[0]?.remaining) || "0";
          }
        } catch (e) {}
      } else {
        eRROR = availityData.apiStatus || "API Error";
      }
    } else {
      eRROR = "Availity Error";
    }

    // Now pass these values to your saveUpdateClaimData call:
   await saveUpdateClaimData(
  "", // CLM_CLAIM_ID
  taskId, // CLM_TASK_ID
  memberId, // CLM_MEMBER_ID
  groupId, // CLM_GROUP_ID
  contract, // CLM_CONTRACT_DESC
  "", // CLM_CONTRACT_ID
  aVL_GROUP_ID,
  aVL_PATIENT_SUB_FLAG,
  aVL_SUBSCRIBER_FIRST_NAME,
  aVL_SUBSCRIBER_ID,
  aVL_SUBSCRIBER_LAST_NAME,
  aVL_SUBSCRIBER_REL_FLAG,
  aVL_DEDUCTIBLE_Total,
  aVL_DEDUCTIBLE,
  aVL_CO_INS,
  aVL_COPAY,
  aVL_OOP_Total,
  aVL_OOP_REM,
  aVL_MEMB_GENDER,
  aVL_SUB_GENDER,
  billedAmount, // BILLED_AMOUNT
  user, // LAST_USER
  eRROR // ERROR
);}catch (err) {
        await saveUpdateClaimData(
     "",
    taskId || "",
     memberID || "",
     groupId || "",
    contract || "",
     "",
     "",
     "",
     "",
     "",
     "",
     "",
    0,
     0,
    0,
    0,
    0,
    0,
  "",
   "",
   Number(billedAmount) || 0,
   user || "",
   err.message || "exception"
  );

    }
  

    // ...rest of your logic...


  // ...existing code...




      }

      const result = await unlockRXDetails (taskPayload.Contract, taskPayload.UserID, taskPayload.TaskID
        , taskPayload.PharmacyID);

        if (result.success) {
            toast.success('Task unlocked successfully');
            // navigate('/process-prescription');
            setShowThankYou(true);
          } else {
            toast.error(result.message || 'Failed to unlock task');
            navigate('/error-page');
          }
    } catch (error) {
      console.error("Save prescription failed:", error);
      toast.error("Failed to submit prescription");
      navigate('/error-page');
    } finally {
      setIsSubmitting(false);
    }
  };

  // making it non-editable
//   const readOnlyColumns = columns.map(col => ({
//   ...col,
//   editable: false  // Override any editable flags
// }));

const columns = [
    { field: 'MedStartDate', headerName: 'Med Start Date',flex:.8, headerClassName: 'pink-header', sortable: false,
      renderHeader: () => (
        <span style={{ whiteSpace: 'pre-line', wordBreak: 'break-word', textAlign: 'center' }}>
          Med Start<br />Date
        </span>
      )
     },
    { field: 'NDC', headerName: 'NDC', flex:1, headerClassName: 'pink-header', sortable: false },
    { field: 'DrugName', headerName: 'Drug Name', flex:1, headerClassName: 'pink-header', sortable: false,
      renderCell: (params) => (
      <div
        style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          lineHeight: 1.8,
          padding: '10px 2px',
          width: '100%',
        }}
      >
        {params.value}
      </div>
      )
     },
    { field: 'GPIName', headerName: 'GPI Name',flex:.8, headerClassName: 'pink-header', sortable: false,
      renderCell: (params) => (
      <div
        style={{
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          lineHeight: 1.8,
          padding: '10px 2px',
          width: '100%',
        }}
      >
        {params.value}
      </div>
      )
     },
    { field: 'AppQty', headerName: 'App Qty', flex:.6, headerClassName: 'pink-header', sortable: false },
    { field: 'Units', headerName: 'Units', flex:.6, headerClassName: 'pink-header', sortable: false },
    { field: 'Disp Qty', headerName: 'Disp Qty',flex:.6, headerClassName: 'pink-header', sortable: false },
    { field: 'Cancel Qty', headerName: 'Cancel Qty', flex:.8, headerClassName: 'pink-header', sortable: false },
    { field: 'Reason', headerName: 'Reason', flex:1, headerClassName: 'pink-header', sortable: false },
    //{ field: 'Reimbursement Amount', headerName: 'Amount', width: 100, headerClassName: 'pink-header' }
  ];{
    // member pays and reimbursement amount columns
    if((rxData?.ContractType && rxData.ContractType.trim() !== '' ) || ( rxData[0]?.ContractType && 
  rxData[0]?.ContractType.trim() !== '') || Contract === 'Moelis-Cigna-Premier Rx') {
      columns.push({ field: 'Member Pays', headerName: 'Member Pay', width: 80, headerClassName: 'pink-header', sortable: false });
  //   }else if(rxData[0]?.Contract && rxData[0].Contract.trim() === 'HMO Illinois' || Contract === 'HMO Illinois' || Contract === "WINFertilityRx"
  // || Contract === "WINFertility DTC") {
  //     columns.push({ field: 'Member Pays', headerName: 'Member Pay', width: 80, headerClassName: 'pink-header', sortable: false });
  // }
  }

    if((rxData?.ContractType && rxData.ContractType.trim() !== '' ) || ( rxData[0]?.ContractType && 
  rxData[0]?.ContractType.trim() !== '') || Contract === 'Moelis-Cigna-Premier Rx') {
      columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursement Amount', flex:1, headerClassName: 'pink-header', sortable: false });
    }else if(rxData[0]?.Contract && rxData[0].Contract.trim() === 'HMO Illinois' || Contract === 'HMO Illinois' 
    || Contract === "WINFertilityRx" || Contract === "WINFertility DTC" || Contract === "CIGNA") {
      columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursment Amount',flex:1, headerClassName: 'pink-header', sortable: false });
  }
}

let totalReimbursement = 0;
let totalMemberPay = 0;
let totalMenopur = 0;
let totalMemberPayMenopur = 0;
let summaryRow = {};
let mainSummayRow = {}; 
let menopurSummaryRow = {};

if (memberConcernFlag === true && (rxData[0]?.ContractType === 'Premier' 
  || Contract === 'Moelis-Cigna-Premier Rx'
)) {
  totalReimbursement = maingridRows.reduce(
    (sum, row) => sum + parseFloat(row['Reimbursment Amount'] || 0),
    0
  );

  totalMemberPay = maingridRows.reduce(
    (sum, row) => sum + parseFloat(row['Member Pays'] || 0),
    0
  );

  totalMenopur = menopurGridRows.reduce(
    (sum, row) => sum + parseFloat(row['Reimbursment Amount'] || 0),
    0
  );

  totalMemberPayMenopur = menopurGridRows.reduce(
    (sum, row) => sum + parseFloat(row['Member Pays'] || 0),
    0
  );

  mainSummayRow = {
    id: 'summary-row',
    'Reimbursment Amount': totalReimbursement.toFixed(2),
    'Member Pays': totalMemberPay.toFixed(2),
  };
  menopurSummaryRow = {
    id: 'summary-row',
    'Reimbursment Amount': totalMenopur.toFixed(2), 
    'Member Pays': totalMemberPayMenopur.toFixed(2),
  };

} else {

totalReimbursement = gridRows.reduce(
  (sum, row) => sum + parseFloat(row['Reimbursment Amount'] || 0),
  0
);

totalMemberPay = gridRows.reduce(
  (sum, row) => sum + parseFloat(row['Member Pays'] || 0),
  0
);

summaryRow = {
  id: 'summary-row',
  'Reimbursment Amount': totalReimbursement.toFixed(2),
  'Member Pays': totalMemberPay.toFixed(2),
};
}

const rowsWithSummary = [...gridRows, summaryRow];
const mainRowsWithSummary = [...maingridRows, mainSummayRow];
const menopurRowsWithSummary = [...menopurGridRows, menopurSummaryRow];

  

  return (
    <>
    <div
      className="order-summary"
      style={{
        padding: '40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
        <Toaster position="top-right" />
      <div style={{ marginBottom: '10px' }}>
        <img src={logo} alt="WIN Logo" style={{ height: '60px', width: '120px' }} />
      </div>

      <h3 style={{ color: '#ec008c', textAlign: 'center', fontSize: '22px', padding: '2px auto', margin: '2px auto' }}>Order Summary</h3>
       <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'right', alignItems: 'center', width: '100%', marginBottom: '10px', marginRight: '400px' }}>
  <FcPrint className = 'no-print' style={{ fontSize: '40px', cursor: 'pointer' }} onClick={() => window.print()} />
</div>

      <div
        className="member-summary"
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '5px',
          marginBottom: '5px',
          width: '80%'
        }}
      >

       
        
        <p style={{fontSize: '14px'}}><strong>Name:</strong> {rxData[0].MemberName || rxData.MemberName}</p>
        <p style={{fontSize: '14px'}}><strong>Med Start Date:</strong> {rxData[0].SchStartDate}</p>
        <p style={{fontSize: '14px'}}><strong>Provider Name:</strong> {rxData[0].SerProName}</p>
        <p style={{fontSize: '14px'}}><strong>Member ID:</strong> {rxData[0].MemberID}</p>
        <p style={{fontSize: '14px'}}><strong>Filled:</strong> {formattedDate} {formattedTime}</p>
        <p style={{fontSize: '14px'}}><strong>Provider Phone:</strong> {rxData[0].Telephone}</p>
        <p style={{fontSize: '14px'}}><strong>Received:</strong> {rxData[0].ReceivedDate}</p>
        <p style={{fontSize: '14px'}}><strong>Submitted:</strong> {formattedDate}</p>
        <p style={{fontSize: '14px'}}><strong>Provider Fax:</strong> {rxData[0].Fax}</p>
        { ((Contract === 'HMO Illinois') || 
        (Contract === "Moelis-Cigna-Premier Rx") ||
         (rxData?.ContractType?.trim() === 'Premier' || rxData[0]?.ContractType?.trim() === 'Premier') 
         || (Contract === "WINFertility DTC" || Contract === "WINFertilityRx")  ) && (
       <>
        <p style={{ fontSize: '14px' }}>
          <strong>#Tracking No:</strong> {trackingNumber}
        </p>
        <p style={{ fontSize: '14px' }}>
          <strong>Shipping Carrier:</strong> {shippingCarrier}
        </p>
      </>
        )}
      </div>

      <div className="prescription-summary" style={{ width: '80%' }}>
        <div style={{ height: 'auto' }} className="no-print">
        <h3 style={{ color: '#ec008c', textAlign: 'center', fontSize: '22px', padding: '2px auto', margin: '2px auto' }}>Prescriptions</h3>
        
          { (rxData[0]?.ContractType === 'Premier' || 
          Contract === "Moelis-Cigna-Premier Rx" ) && memberConcernFlag === true && (
            <>
            {( maingridRows.length > 0) && (
              <DataGrid
                rows={mainRowsWithSummary}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                hideFooter
                getRowClassName={(params) =>
                  params.row.isSummary ? 'summary-row' : ''
                }
                sx={{
                      fontSize: '12px',
                      fontFamily: 'Segoe UI',
                      '& .pink-header': {
                        color: '#fff',
                        backgroundColor: '#ec008c',
                        fontWeight: 'bold',
                         whiteSpace: 'normal !important',
            wordBreak: 'breakWord !important',
            overflowWrap: 'breakWord !important',
            lineHeight: '1.3 !important',
            textAlign: 'center', /* Optional: center the header text */
            padding: '8px 2px !important',
                      },
                       '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f5f5f5 !important',
                        cursor: 'pointer',
                      },// Remove blue outline on cell focus
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
                backgroundColor: 'none !important',  
               },
               //'& .MuiDataGrid-row:focus-within': {
              //   backgroundColor: '#f5bcbc !important',
              // },
              // Remove blue outline on column header focus
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
                    }}
              /> )}
              <DataGrid
                rows={menopurRowsWithSummary}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
                hideFooter
                getRowClassName={(params) =>
                  params.row.isSummary ? 'summary-row' : ''
                }
                sx={{
                      fontSize: '12px',
                      fontFamily: 'Segoe UI',
                      '& .pink-header': {
                        color: '#fff',
                        backgroundColor: '#ec008c',
                        fontWeight: 'bold',
                         whiteSpace: 'normal !important',
            wordBreak: 'breakWord !important',
            overflowWrap: 'breakWord !important',
            lineHeight: '1.3 !important',
            textAlign: 'center', /* Optional: center the header text */
            padding: '8px 2px !important',
                      },
                       '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f5f5f5 !important',
                        cursor: 'pointer',
                      },// Remove blue outline on cell focus
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
                backgroundColor: 'none !important',  
               },
               //'& .MuiDataGrid-row:focus-within': {
              //   backgroundColor: '#f5bcbc !important',
              // },
              // Remove blue outline on column header focus
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
                    }}
              />
            </>
          )}
                                { (memberConcernFlag === false &&(<DataGrid
                                  rows={rowsWithSummary}
                                  columns={columns}
                                  pageSize={5}
                                  rowsPerPageOptions={[5]}
                                  hideFooter
                                  getRowClassName={(params) =>
                                  params.row.isSummary ? 'summary-row' : ''}
                                  sx={{
                      fontSize: '12px',
                      fontFamily: 'Segoe UI',
                      '& .pink-header': {
                        color: '#fff',
                        backgroundColor: '#ec008c',
                        fontWeight: 'bold',
                         whiteSpace: 'normal !important',
            wordBreak: 'breakWord !important',
            overflowWrap: 'breakWord !important',
            lineHeight: '1.3 !important',
            textAlign: 'center', /* Optional: center the header text */
            padding: '8px 2px !important',
                      },
                       '& .MuiDataGrid-row:hover': {
                        backgroundColor: '#f5f5f5 !important',
                        cursor: 'pointer',
                      },// Remove blue outline on cell focus
              '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
                backgroundColor: 'none !important',  
               },
               //'& .MuiDataGrid-row:focus-within': {
              //   backgroundColor: '#f5bcbc !important',
              // },
              // Remove blue outline on column header focus
              '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                outline: 'none !important',
                boxShadow: 'none !important',
              },
                    }}
                                />))}
        </div>

          <div className="print-only">
  <h2 style={{ color: '#ec008c', textAlign: 'center' }}>Prescriptions</h2>
{ !memberConcernFlag && ( 
  <table className="print-table">
     
    <thead>
      <tr>
        <th>Med Start Date</th>
        <th>NDC</th>
        <th>Drug Name</th>
        <th>GPI Name</th>
        <th>App Qty</th>
        <th>Units</th>
        <th>Disp Qty</th>
        <th>Cancel Qty</th>
        <th>Member Pay</th>
        <th>Reimbursement Amount</th>
      </tr>
    </thead>
   
    <tbody>
      {rowsWithSummary.map((r) => (
        <tr key={r.id}>
          <td>{r.MedStartDate}</td>
          <td>{r.NDC}</td>
          <td>{r.DrugName}</td>
          <td>{r.GPIName}</td>
          <td>{r.AppQty}</td>
          <td>{r.Units}</td>
          <td>{r.DispQty}</td>
          <td>{r.CancelQty}</td>
          <td>{r.MemberPays ?? r['Member Pays'] ?? '0.00'}</td>
          <td>
            {r.ReimbursementAmountDisplay ??
             r['Reimbursment Amount'] ??
             r.ReimbursementAmount ??
             '0.00'}
          </td>
        </tr>
      ))}
      
    </tbody>
  </table>)}
{ memberConcernFlag && ( 
  <table className="print-table">
     
    <thead>
      <tr>
        <th>Med Start Date</th>
        <th>NDC</th>
        <th>Drug Name</th>
        <th>GPI Name</th>
        <th>App Qty</th>
        <th>Units</th>
        <th>Disp Qty</th>
        <th>Cancel Qty</th>
        <th>Member Pay</th>
        <th>Reimbursement Amount</th>
      </tr>
    </thead>
   
    <tbody>
      {mainRowsWithSummary.map((r) => (
        <tr key={r.id}>
          <td>{r.MedStartDate}</td>
          <td>{r.NDC}</td>
          <td>{r.DrugName}</td>
          <td>{r.GPIName}</td>
          <td>{r.AppQty}</td>
          <td>{r.Units}</td>
          <td>{r.DispQty}</td>
          <td>{r.CancelQty}</td>
          <td>{r.MemberPays ?? r['Member Pays'] ?? '0.00'}</td>
          <td>
            {r.ReimbursementAmountDisplay ??
             r['Reimbursment Amount'] ??
             r.ReimbursementAmount ??
             '0.00'}
          </td>
        </tr>
      ))}
      
    </tbody>
  </table>)}
{ memberConcernFlag && ( 
  <table className="print-table">
     
    <thead>
      <tr>
        <th>Med Start Date</th>
        <th>NDC</th>
        <th>Drug Name</th>
        <th>GPI Name</th>
        <th>App Qty</th>
        <th>Units</th>
        <th>Disp Qty</th>
        <th>Cancel Qty</th>
        <th>Member Pay</th>
        <th>Reimbursement Amount</th>
      </tr>
    </thead>
   
    <tbody>
      {menopurRowsWithSummary.map((r) => (
        <tr key={r.id}>
          <td>{r.MedStartDate}</td>
          <td>{r.NDC}</td>
          <td>{r.DrugName}</td>
          <td>{r.GPIName}</td>
          <td>{r.AppQty}</td>
          <td>{r.Units}</td>
          <td>{r.DispQty}</td>
          <td>{r.CancelQty}</td>
          <td>{r.MemberPays ?? r['Member Pays'] ?? '0.00'}</td>
          <td>
            {r.ReimbursementAmountDisplay ??
             r['Reimbursment Amount'] ??
             r.ReimbursementAmount ??
             '0.00'}
          </td>
        </tr>
      ))}
      
    </tbody>
  </table>)}
</div>

        {/* {((rxData?.ContractType?.trim() === 'Premier' || rxData[0]?.ContractType?.trim() === 'Premier' ||
         Contract === 'Moelis-Cigna-Premier Rx')
        &&(Contract !== 'Chewy-Aetna-Premier'))  && (
    <>
      <div style={{ marginLeft: '20px', color: '#000' }}>
        Member Cost Share: ${TotalMemberPays}
      </div>
      <div style={{ marginLeft: '20px', color: '#000' }}>
        WIN To Pharmacy: ${TotalWinPays}
      </div>
    </>
  )} */}
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '40px' }}>

  {((rxData?.ContractType?.trim() === 'Premier' || rxData[0]?.ContractType?.trim() === 'Premier' || 
  Contract === 'Moelis-Cigna-Premier Rx') ) && (
      <>
        <div style={{ color: '#000', marginBottom: '6px' }}>
          Member Cost Share: ${parseFloat(TotalMemberPays).toFixed(2)}
        </div>
        <div style={{ color: '#000' }}>
          WIN To Pharmacy: ${parseFloat(TotalWinPays).toFixed(2)}
        </div>
        {((rxData[0]?.ContractType === 'Premier' ||Contract === 'Moelis-Cigna-Premier Rx' ) && memberConcernFlag) && (
          <div style={{ color: '#000' }}>
          WIN Card Value: ${parseFloat(totalWinCardAmount).toFixed(2)}
        </div>
        )}
      </>
     )} 

     {(Contract === 'HMO Illinois' ||Contract === "CIGNA" || Contract === 'WINFertilityRx' || Contract === 'WINFertility DTC') && (
        <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px' }}>
          Total Amount: ${totalAmount}
        </div>
        )}
    </div>
  
  
   
        <div className="button-div" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '30px' }}>
        <button className="button-open-order" onClick={onCancel}>
            Cancel
            </button>

            <button className="button-open-order" onClick={handleProceed}
            disabled = {isSubmitting}>{isSubmitting ? "Submitting..." : "Proceed"}</button>
        </div>
      </div>
    </div>
    <ThankYouModal open={showThankYou} />

    </>
  );
};

export default OrderSummary;
